import { useState, useEffect } from "react";
import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink,
  useNavigate
} from "react-router-dom";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

import * as API from "../services/analiticas";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllAnaliticasByTax(params.tratamientoId);
}

export function AnaliticasComparativaItem(props) {
  const analiticas = useLoaderData();
  console.log(analiticas);
  const navigate = useNavigate();

  const renderEmptyMessage = () => {
    if (analiticas.length === 0) {
      return <h1>Aquí podrás ver la evolución de tus resultados. Actualmente no existen datos para comparar.</h1>;
    }
    return null;
  };

  useEffect(() => {
    if (analiticas.length === 1) {
      const objectId = analiticas[0].id; // Obtén el ID del único objeto
      navigate(`${objectId}`); // Navega a la URL con el ID
    }
  }, [analiticas, navigate]);

  // Función para transformar los datos de analíticas
  const transformAnaliticasData = (analitica) => {
    return {
      fecha: new Date(analitica.meta?.analiFechaAnali).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }),
      analiHematiesResult: Number(analitica.meta?.analiHematiesResult),
      analiHemoglobResult: Number(analitica.meta?.analiHemoglobResult),
      analiHematcrResult: Number(analitica.meta?.analiHematcrResult),
      analiVcmResult: Number(analitica.meta?.analiVcmResult),
      analiHcmResult: Number(analitica.meta?.analiHcmResult),
      analiChcmResult: Number(analitica.meta?.analiChcmResult),
      analiIdhResult: Number(analitica.meta?.analiIdhResult),
      analiLeucoResult: Number(analitica.meta?.analiLeucoResult),
      analiNeutrResult: Number(analitica.meta?.analiNeutrResult),
      analiLinfoResult: Number(analitica.meta?.analiLinfoResult),
      analiMonocResult: Number(analitica.meta?.analiMonocResult),
      analiEosinResult: Number(analitica.meta?.analiEosinResult),
      analiBasofResult: Number(analitica.meta?.analiBasofResult),
      analiPlaqResult: Number(analitica.meta?.analiPlaqResult),
      analiPctResult: Number(analitica.meta?.analiPctResult),
      analiVpmResult: Number(analitica.meta?.analiVpmResult),
      analiIdpResult: Number(analitica.meta?.analiIdpResult),
      analiTieProtResult: Number(analitica.meta?.analiTieProtResult),
      analiActProtResult: Number(analitica.meta?.analiActProtResult),
      analiInrResult: Number(analitica.meta?.analiInrResult),
      analiGlucResult: Number(analitica.meta?.analiGlucResult),
      analiUreaResult: Number(analitica.meta?.analiUreaResult),
      analiCreatResult: Number(analitica.meta?.analiCreatResult),
      analiGlomResult: Number(analitica.meta?.analiGlomResult),
      analiAsparResult: Number(analitica.meta?.analiAsparResult),
      analiAlanResult: Number(analitica.meta?.analiAlanResult),
      analiGammResult: Number(analitica.meta?.analiGammResult),
      analiFosfResult: Number(analitica.meta?.analiFosfResult),
      analiBiliResult: Number(analitica.meta?.analiBiliResult),
      analiColestResult: Number(analitica.meta?.analiColestResult),
      analiColestHdlResult: Number(analitica.meta?.analiColestHdlResult),
      analiColestLdlResult: Number(analitica.meta?.analiColestLdlResult),
      analiTriglResult: Number(analitica.meta?.analiTriglResult),
      analiCalcResult: Number(analitica.meta?.analiCalcResult),
      analiHierrResult: Number(analitica.meta?.analiHierrResult),
      analiSodResult: Number(analitica.meta?.analiSodResult),
      analiPotasResult: Number(analitica.meta?.analiPotasResult),
      analiVitbResult: Number(analitica.meta?.analiVitbResult),
      analiVitohResult: Number(analitica.meta?.analiVitohResult),
      analiAcidfolResult: Number(analitica.meta?.analiAcidfolResult),
      analiMagnResult: Number(analitica.meta?.analiMagnResult),
      analiFerriResult: Number(analitica.meta?.analiFerriResult),
      analiProtcResult: Number(analitica.meta?.analiProtcResult),
      analiCortiResult: Number(analitica.meta?.analiCortiResult),
      analiDheaResult: Number(analitica.meta?.analiDheaResult),
      analiDheaSResult: Number(analitica.meta?.analiDheaSResult),
    };
  };

  // Ordenar las analíticas por fecha de más antiguas a más recientes
  const sortedAnaliticas = analiticas.sort(
    (a, b) => new Date(a.meta?.analiFechaAnali) - new Date(b.meta?.analiFechaAnali)
  );

  // Transforma todas las analíticas
  const transformedAnaliticasList = sortedAnaliticas.map(transformAnaliticasData);
  console.log(transformedAnaliticasList)

  return (
    <>
      <div id="content" className='comparativa-graficas-container'>
      {renderEmptyMessage() || (
        <form className="analitic-form">
          <h3>Hematología</h3>
          <div className="three-col-analitic">
            <div className="anali-el">
              <p className="anali-title">Hematies</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiHematiesResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Hemoglobina</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiHemoglobResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Hematocrito</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiHematcrResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">VCM</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiVcmResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">HCM</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiHcmResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">CHCM</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiChcmResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">IDH</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiIdhResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Leucocitos</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiLeucoResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Neutrófilos segmentados</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiNeutrResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Linfocitos</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiLinfoResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Monocitos</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiMonocResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Eosinófilos</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiEosinResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Basófilos</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiBasofResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Plaquetas</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiPlaqResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">PCT</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiPctResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">VPM</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiVpmResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">IDP</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiIdpResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

          </div>
          <h3>Coagulación</h3>
          <div className="three-col-analitic">
            <div className="anali-el">
              <p className="anali-title">Tiempo de Protrombina (seg)</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiTieProtResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">Actividad de Protrombina (%)</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiActProtResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

            <div className="anali-el">
              <p className="anali-title">INR</p>
              <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  {/* <CartesianGrid strokeDasharray="1 1" /> */}
                  <XAxis 
                    axisLine={{ strokeWidth: 0 }} 
                    dataKey="fecha" 
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line 
                    type="monotone" 
                    dataKey="analiInrResult"
                    stroke="#29ade6" 
                    strokeWidth={8}  
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
              </div>
            </div>

          </div>
          <h3>Bioquímica</h3>
          <div className="three-col-analitic">

          <div className="anali-el">
            <p className="anali-title">Glucosa, Suero/Pl</p>
            <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  <XAxis
                    axisLine={{ strokeWidth: 0 }}
                    dataKey="fecha"
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="analiGlucResult"
                    stroke="#29ade6"
                    strokeWidth={8}
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="anali-el">
            <p className="anali-title">Urea, Suero/Pl</p>
            <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  <XAxis
                    axisLine={{ strokeWidth: 0 }}
                    dataKey="fecha"
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="analiUreaResult"
                    stroke="#29ade6"
                    strokeWidth={8}
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="anali-el">
            <p className="anali-title">Creatinina, Suero/Pl</p>
            <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  <XAxis
                    axisLine={{ strokeWidth: 0 }}
                    dataKey="fecha"
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="analiCreatResult"
                    stroke="#29ade6"
                    strokeWidth={8}
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="anali-el">
            <p className="anali-title">Filtrado Glomerular CKD-EPI</p>
            <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  <XAxis
                    axisLine={{ strokeWidth: 0 }}
                    dataKey="fecha"
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="analiGlomResult"
                    stroke="#29ade6"
                    strokeWidth={8}
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="anali-el">
            <p className="anali-title">Aspartato Amino Transferasa (AST/GOT), Suero/Pl</p>
            <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  <XAxis
                    axisLine={{ strokeWidth: 0 }}
                    dataKey="fecha"
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="analiAsparResult"
                    stroke="#29ade6"
                    strokeWidth={8}
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="anali-el">
            <p className="anali-title">Alanina Amino Transferasa (ALT/GPT), Suero/Pl</p>
            <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  <XAxis
                    axisLine={{ strokeWidth: 0 }}
                    dataKey="fecha"
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="analiAlanResult"
                    stroke="#29ade6"
                    strokeWidth={8}
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="anali-el">
            <p className="anali-title">Gamma Glutamil Transferasa (GGT), Suero/Pl</p>
            <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  <XAxis
                    axisLine={{ strokeWidth: 0 }}
                    dataKey="fecha"
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="analiGammResult"
                    stroke="#29ade6"
                    strokeWidth={8}
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="anali-el">
            <p className="anali-title">Fosfatasa Alcalina (FA), Suero/Pl</p>
            <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  <XAxis
                    axisLine={{ strokeWidth: 0 }}
                    dataKey="fecha"
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="analiFosfResult"
                    stroke="#29ade6"
                    strokeWidth={8}
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="anali-el">
            <p className="anali-title">Bilirrubina total, Suero/Pl</p>
            <div className="anali-result-container">
              <ResponsiveContainer width="100%" height={300}>
                <LineChart
                  width={600}
                  height={300}
                  data={transformedAnaliticasList}
                  margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
                >
                  <XAxis
                    axisLine={{ strokeWidth: 0 }}
                    dataKey="fecha"
                    padding={{ left: 50, right: 40 }}
                    dy={10}
                  />
                  <YAxis hide={true} domain={[0, 'dataMax']} />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="analiBiliResult"
                    stroke="#29ade6"
                    strokeWidth={8}
                    label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
                    dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>

          <div className="anali-el">
  <p className="anali-title">Colesterol, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiColestResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Colesterol HDL, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiColestHdlResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Colesterol LDL, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiColestLdlResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Triglicéridos, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiTriglResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Calcio, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiCalcResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Hierro, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiHierrResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Sodio, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiSodResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Potasio, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiPotasResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Vitamina B12, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiVitbResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">25-OH Vitamina D</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiVitohResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Ácido Fólico (Folato), Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiAcidfolResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Magnesio, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiMagnResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

</div>
          <h3>Proteínas</h3>
          <div className="three-col-analitic">

<div className="anali-el">
  <p className="anali-title">Ferritina, Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiFerriResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">Proteína C Reactiva (PCR), Suero/Pl</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiProtcResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

</div>
          <h3>Analítica B</h3>
          <div className="three-col-analitic">

<div className="anali-el">
  <p className="anali-title">Cortisol</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiCortiResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">DHEA</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiDheaResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>

<div className="anali-el">
  <p className="anali-title">DHEA-S</p>
  <div className="anali-result-container">
    <ResponsiveContainer width="100%" height={300}>
      <LineChart
        width={600}
        height={300}
        data={transformedAnaliticasList}
        margin={{ top: 50, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis
          axisLine={{ strokeWidth: 0 }}
          dataKey="fecha"
          padding={{ left: 50, right: 40 }}
          dy={10}
        />
        <YAxis hide={true} domain={[0, 'dataMax']} />
        <Tooltip />
        <Line
          type="monotone"
          dataKey="analiDheaSResult"
          stroke="#29ade6"
          strokeWidth={8}
          label={{ position: 'top', fill: '#29ade6', fontSize: 36, fontWeight: 'bold', offset: 20 }}
          dot={{ r: 6, fill: '#29ade6', stroke: '#fff', strokeWidth: 4 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>




          </div>
          </form>
        )}
      </div>
      <div id="actions">
      </div>
    </>
  );
}